import { render, staticRenderFns } from "./RepairCard.vue?vue&type=template&id=d6f23e3c&scoped=true"
import script from "./RepairCard.vue?vue&type=script&lang=js"
export * from "./RepairCard.vue?vue&type=script&lang=js"
import style0 from "./RepairCard.vue?vue&type=style&index=0&id=d6f23e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f23e3c",
  null
  
)

export default component.exports